import { combineReducers } from '@reduxjs/toolkit';
import filtersReducer from './filtersSlice';
import ldTeamsReducer from './Teams/ldTeamsSlice';
import businessTeamsReducer from './Teams/businessTeamsSlice';
import processesReducer from './Processes/processesSlice';
import stagesReducer from './Processes/stagesSlice';
import categoriesReducer from './Categories/categoriesSlice';

export default combineReducers({
  values: filtersReducer,
  ldTeams: ldTeamsReducer,
  businessTeams: businessTeamsReducer,
  processes: processesReducer,
  stages: stagesReducer,
  categories: categoriesReducer,
});
